import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { PageService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class PageListPageResolve implements Resolve<any> {

  constructor(private pageService: PageService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.pageService.listPage();
  }
}
